var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302,
    height: 121,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.018,
    cy: 109.938,
    fill: "#F2F2F2",
    fillRule: "nonzero",
    rx: 147.346,
    ry: 9.755
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    fillRule: "nonzero",
    d: "M145.37 3.15c-24.006 0-41.243 15.403-41.243 51.341 0 40.73 17.237 51.511 41.243 51.511 24.007 0 42.27-11.808 42.27-51.511 0-42.441-18.263-51.34-42.27-51.34Zm.158 89.333c-16.628 0-25.314-9.755-25.314-37.966 0-24.891 9.042-38.018 25.67-38.018 16.627 0 25.67 8.622 25.67 38.018 0 27.5-9.398 37.966-26.026 37.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFA6",
    fillRule: "nonzero",
    d: "M89.752 77.594h-9.926V48.365a5.854 5.854 0 0 0-5.854-5.853h-2.325a5.854 5.854 0 0 0-5.854 5.853v29.23H37.796a3.342 3.342 0 0 1-2.955-4.904l29.632-56.084a5.854 5.854 0 0 0-2.676-8.027l-1.75-.826a5.854 5.854 0 0 0-7.661 2.533l-36.14 67.607a7.937 7.937 0 0 0 7 11.68h42.547v18.482a7.016 7.016 0 0 0 7.016 7.016 7.016 7.016 0 0 0 7.017-7.016V89.573h9.926a5.99 5.99 0 0 0 0-11.98ZM273.55 77.594h-9.926V48.365a5.854 5.854 0 0 0-5.854-5.853h-2.325a5.854 5.854 0 0 0-5.854 5.853v29.23h-27.997a3.342 3.342 0 0 1-2.955-4.904l29.632-56.084a5.854 5.854 0 0 0-2.676-8.027l-1.75-.826a5.854 5.854 0 0 0-7.661 2.533l-36.14 67.607a7.937 7.937 0 0 0 7 11.68h42.547v18.482a7.016 7.016 0 1 0 14.033 0V89.573h9.926a5.99 5.99 0 0 0 0-11.98v.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M92.49 74.171h-9.926V44.942a5.854 5.854 0 0 0-5.853-5.853h-2.326a5.854 5.854 0 0 0-5.854 5.853v29.23H40.534a3.342 3.342 0 0 1-2.955-4.903l29.632-56.084a5.854 5.854 0 0 0-2.676-8.028l-1.75-.826a5.854 5.854 0 0 0-7.66 2.534L18.983 74.47a7.937 7.937 0 0 0 7 11.68h42.547v18.482a7.016 7.016 0 0 0 7.017 7.017 7.016 7.016 0 0 0 7.016-7.017V86.151h9.926a5.99 5.99 0 0 0 5.99-5.99 5.99 5.99 0 0 0-5.99-5.99ZM278.684 74.171h-9.926V44.942a5.854 5.854 0 0 0-5.854-5.853h-2.325a5.854 5.854 0 0 0-5.854 5.853v29.23h-27.997a3.342 3.342 0 0 1-2.955-4.903l29.632-56.084a5.854 5.854 0 0 0-2.676-8.028l-1.75-.826a5.854 5.854 0 0 0-7.661 2.534l-36.14 67.606a7.937 7.937 0 0 0 7 11.68h42.547v18.482a7.016 7.016 0 1 0 14.033 0V86.151h9.926a5.99 5.99 0 0 0 5.99-5.99 5.99 5.99 0 0 0-5.99-5.99ZM150.847.07c-24.007 0-41.244 15.402-41.244 51.34 0 40.73 17.237 51.512 41.244 51.512 24.006 0 42.27-11.808 42.27-51.511 0-42.442-18.264-51.34-42.27-51.34Zm.157 89.332c-16.627 0-25.314-9.755-25.314-37.965 0-24.892 9.042-38.018 25.67-38.018s25.67 8.622 25.67 38.018c0 27.5-9.398 37.965-26.026 37.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M281.247 73.693a5.814 5.814 0 1 0 .774-11.15l.146 2.992-1.416-2.564a5.792 5.792 0 0 0-2.984 3.274 5.812 5.812 0 0 0 3.48 7.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M288.252 108.398c-.5-2.545 1.665-4.801 3.804-6.268 2.14-1.466 4.639-2.907 5.369-5.395 1.048-3.577-2.076-6.852-4.508-9.677a35 35 0 0 1-4.615-6.86c-.506-.986-.971-2.018-1.104-3.119-.192-1.585.317-3.162.83-4.675a338.09 338.09 0 0 1 5.483-14.986"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M281.486 72.922a5.814 5.814 0 1 0 .774-11.15l.146 2.993-1.416-2.564a5.792 5.792 0 0 0-2.984 3.274 5.812 5.812 0 0 0 3.48 7.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M287.541 56.385a5.807 5.807 0 0 1 4.185-3.687l.478 2.845.888-2.988a5.813 5.813 0 1 1-5.55 3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M287.86 55.358a5.807 5.807 0 0 1 4.185-3.687l.478 2.845.888-2.988a5.813 5.813 0 1 1-5.55 3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M291.897 87.116a5.813 5.813 0 0 0 5.145-10.342l-.682 2.296-.484-2.878a5.813 5.813 0 1 0-3.98 10.924Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M292.173 86.075a5.813 5.813 0 0 0 5.145-10.341l-.681 2.296-.484-2.878a5.813 5.813 0 1 0-3.98 10.924Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M285.845 96.77a5.81 5.81 0 1 0 1.12-4.552l2.59 3.898-3.539-2.069a5.759 5.759 0 0 0-.171 2.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M286.084 96a5.81 5.81 0 1 0 1.12-4.553l2.59 3.899-3.539-2.07a5.759 5.759 0 0 0-.17 2.724Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M2.516 87.854a3.82 3.82 0 1 0 .509-7.325l.095 1.966-.93-1.685a3.805 3.805 0 0 0-2.18 3.185 3.819 3.819 0 0 0 2.506 3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M7.118 110.656c-.328-1.672 1.095-3.154 2.5-4.118 1.405-.963 3.048-1.91 3.527-3.545.69-2.35-1.364-4.501-2.961-6.357a22.996 22.996 0 0 1-3.033-4.507 6.204 6.204 0 0 1-.725-2.05c-.126-1.041.209-2.077.546-3.071a222.13 222.13 0 0 1 3.602-9.846"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M2.673 87.348a3.82 3.82 0 1 0 .509-7.325l.096 1.966-.93-1.685a3.805 3.805 0 0 0-2.18 3.185 3.819 3.819 0 0 0 2.505 3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M6.652 76.483A3.815 3.815 0 0 1 9.4 74.06l.314 1.869.583-1.963a3.82 3.82 0 1 1-3.646 2.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M6.861 75.808a3.815 3.815 0 0 1 2.75-2.422l.314 1.869.583-1.963a3.82 3.82 0 1 1-3.647 2.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M9.513 96.674a3.82 3.82 0 0 0 3.38-6.795l-.447 1.508-.318-1.89a3.82 3.82 0 1 0-2.615 7.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M9.695 95.99a3.82 3.82 0 0 0 3.38-6.795l-.448 1.509-.317-1.891a3.82 3.82 0 1 0-2.615 7.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57B894",
    fillRule: "nonzero",
    d: "M5.537 103.017a3.818 3.818 0 1 0 .736-2.991l1.702 2.561-2.326-1.36a3.784 3.784 0 0 0-.112 1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    d: "M5.694 102.51a3.818 3.818 0 1 0 .736-2.99l1.702 2.561-2.325-1.36a3.784 3.784 0 0 0-.113 1.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.437,
    cy: 42.566,
    r: 1.397,
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "f6471ee81daac8ff723e02d0eda47b5b.svg";
export { ForwardRef as ReactComponent };